import { gql } from "@apollo/client";

export const GET_PACKAGE = gql`
  query getPackageById($packageid: String!) {
    getPackageById(packageid: $packageid) {
      name
      shortdescription
      longdescription
      storageamount
      price
      minpurchase
      defaultcode
      promocode
      pertransactionlimit
    }
  }
`;
